module.exports = __webpack_public_path__ + "static/media/Repeat-the-word-kan-du-seie-orde.062d42b3.mp3";